export enum DietaryTypes {
  GlutenFree = "GlutenFree",
  Vegan = "Vegan",
  Vegetarian = "Vegetarian",
  Organic = "Organic",
  TransFatFree = "TransFatFree",
  DairyFree = "DairyFree",
  GmoFree = "GmoFree",
  SoyFree = "SoyFree",
  NutFree = "NutFree",
  PeanutFree = "PeanutFree",
  EggFree = "EggFree",
  CholesterolFree = "CholesterolFree",
  NitratesFree = "NitratesFree",
  NoSugarAdded = "NoSugarAdded",
  CornFree = "CornFree",
  AllergenFree = "AllergenFree"
};